webpackJsonp([232435795724502],{

/***/ 528:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ayudante.a880f9ff.svg";

/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Grid = __webpack_require__(18);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Typography = __webpack_require__(4);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	__webpack_require__(13);
	
	var _Divider = __webpack_require__(10);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HelperImg = __webpack_require__(528);
	
	var styles = {
	  container: {
	    display: 'grid',
	    gridTemplateColumns: 'repeat(12, 1fr)',
	    gridGap: '1rem'
	  },
	  leftImage: {
	    width: '4rem',
	    margin: '0.15rem',
	    paddingRight: 5
	  },
	  typoFontC: {
	    fontFamily: "'Open Sans', sans-serif",
	    lineHeight: '1.2rem',
	    fontSize: '0.8rem',
	    margin: 5,
	    maxWidth: '11rem'
	  },
	  subtitleSection: {
	    fontFamily: "'Open Sans', sans-serif",
	    lineHeight: '1.3rem',
	    fontSize: '1.1rem',
	    margin: 5,
	    fontWeight: 'bold'
	  },
	  listStyle: {
	    background: '#E4E4E4',
	    padding: 5,
	    marginBottom: 0,
	    fontFamily: '"Open Sans", sans-serif'
	  },
	  linkStyle: {
	    color: '#408ed6'
	  }
	};
	
	var RecomendadosPage = function RecomendadosPage(props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h1',
	      { style: { color: '#3A3380', fontSize: '1.25rem', textAlign: 'center', fontWeight: 'bold', marginTop: '1rem' } },
	      'Bibliograf\xEDa Consultada y Recomendada'
	    ),
	    _react2.default.createElement(
	      _Grid2.default,
	      { container: true, spacing: 24 },
	      _react2.default.createElement(
	        _Grid2.default,
	        { item: true, xs: 12, sm: 5 },
	        _react2.default.createElement(
	          'div',
	          { style: { display: 'flex', justifyContent: 'center' } },
	          _react2.default.createElement('img', { src: HelperImg, alt: '', style: { width: '12rem', height: '12rem', margin: '0.5rem' } })
	        ),
	        _react2.default.createElement(
	          _Typography2.default,
	          { variant: 'body2', color: 'caption', style: { marginBottom: 10, fontFamily: "'Indie Flower', sans-serif", fontSize: '1rem' } },
	          'Nos gustar\xEDa recomendarte estos libros, para que puedas aprender un poquito m\xE1s de historia'
	        )
	      ),
	      _react2.default.createElement(
	        _Grid2.default,
	        { item: true, xs: 12, sm: 7 },
	        _react2.default.createElement(
	          _Grid2.default,
	          { container: true, alignItems: 'center', justify: 'center', spacing: 16 },
	          _react2.default.createElement(
	            _Grid2.default,
	            { item: true, xs: 12, sm: 12, alignItems: 'center', justify: 'center',
	              style: { display: 'flex', marginRight: 10, background: '#e1ded4', padding: '2rem' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'recomendados' },
	              _react2.default.createElement(
	                'ul',
	                { style: { listStyleType: 'square' } },
	                _react2.default.createElement(
	                  'li',
	                  { style: styles.listStyle },
	                  'La Argentina: Una historia para pensar 1776-1996. Cristina Rins, Mar\xEDa Felisa Winter. Kapelusz. 1999.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  { style: styles.listStyle },
	                  'Juan Manuel de Rosas: el maldito de nuestra historia oficial. Pacho O\u2019Donnell. Booket. 2001.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  { style: styles.listStyle },
	                  'Martirologio Patrio. Marcial Quiroga. Compa\xF1\xEDa Impresora Argentina. 1991.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  { style: styles.listStyle },
	                  'Juan Manuel de Rosas: El caudillo y su tiempo. Felisberto L\xF3pez Sarabia. Ediciones Libertador. 2007.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  { style: styles.listStyle },
	                  'La Gran Epopeya. Pacho O\u2019Donnell. Grupo Editorial Norma. 2010.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  { style: styles.listStyle },
	                  'El Gaucho Mart\xEDn Fierro. Jos\xE9 Hern\xE1ndez. Imprenta de La Pampa. 1872.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  { style: styles.listStyle },
	                  'Juan Manuel de Rosas: El Restaurador Pol\xEDtico. Colecci\xF3n Bicentenario. Biograf\xEDas Planeta. Alejandro Ulloa. 2009.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  { style: styles.listStyle },
	                  'Revoluciones: Estallidos pol\xEDticos y soluciones constitucionales. F\xE9lix Luna. Planeta. 2006.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  { style: styles.listStyle },
	                  'Correspondencia de Juan Manuel de Rosas. Marcela Ternavasio. Eudeba. 2005.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  { style: styles.listStyle },
	                  'Jos\xE9 Artigas: El Caudillo Revolucionario. Colecci\xF3n Bicentenario. Biograf\xEDas Planeta. Alejandro Ulloa. 2009.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  { style: styles.listStyle },
	                  'Cosa Funesta: El enigma de la muerte de Moreno. Diego Golombek. Editorial Sudamericana. 2004.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  { style: styles.listStyle },
	                  'Historia Pol\xEDtica de las Am\xE9ricas: De los or\xEDgenes a la emancipaci\xF3n. Hugo Chumbita. Universidad Nacional de La Matanza. 2010.'
	                )
	              ),
	              _react2.default.createElement(
	                'h1',
	                { style: { color: '#3A3380', fontSize: '1rem', textAlign: 'center', fontWeight: 'bold', marginTop: '1rem' } },
	                'Adem\xE1s tenemos para recomendar otros sitios de Historia y p\xE1ginas amigas:'
	              ),
	              _react2.default.createElement(
	                'ul',
	                { style: { listStyleType: 'square' } },
	                _react2.default.createElement(
	                  'li',
	                  { style: styles.listStyle },
	                  _react2.default.createElement(
	                    'a',
	                    { style: styles.linkStyle, href: 'https://www.elhistoriador.com.ar/', target: '_blank' },
	                    'El Historiador - de Felipe Pigna'
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  { style: styles.listStyle },
	                  _react2.default.createElement(
	                    'a',
	                    { style: styles.linkStyle, href: 'https://www.efemeridesargentina.com.ar/efemeridesargentina/', target: '_blank' },
	                    'Efem\xE9rides de Argentina'
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  { style: styles.listStyle },
	                  _react2.default.createElement(
	                    'a',
	                    { style: styles.linkStyle, href: 'http://encuentro.gob.ar/', target: '_blank' },
	                    'Canal Encuentro'
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  { style: styles.listStyle },
	                  _react2.default.createElement(
	                    'a',
	                    { style: styles.linkStyle, href: 'https://historiaybiografias.com/historia_argentina/', target: '_blank' },
	                    'Historia y Biograf\xEDas de Argentina'
	                  )
	                )
	              ),
	              _react2.default.createElement(_Divider2.default, { style: { margin: 10 } })
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = RecomendadosPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-recomendados-js-b739c3a41a040a35e393.js